import { notify } from "@kyvg/vue3-notification";

class MessageService {
  popup(self, message, title, type, { duration = 3000, params, group } = {}) {
    notify({
      title: self.$i18n.t(title),
      text: self.$i18n.t(message, params),
      type: type,
      duration: duration,
      group: group
    });
  }

  alert(self, alertMessage, alertClass) {
    let alert = {
      message: self.$i18n.t(alertMessage),
      class: `alert-${alertClass}`
    }

    return alert
  }

  alertWithTitle(self, alertTitle, alertMessage) {
    let alertWithTitle = {
      title: self.$i18n.t(alertTitle),
      message: self.$i18n.t(alertMessage)
    }

    return alertWithTitle
  }
}

const messageService = new MessageService()
export default messageService
